
import { Injectable } from "@angular/core";
import { IID_MAIL_GTW_SOURCE } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDMailGtwStore } from "./iidMailGtw.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.MAIL_GTW_SOURCE)
export class IIDMailGtwQuery extends AbstractInterfaceDataQuery<IID_MAIL_GTW_SOURCE> {
  constructor(protected store: IIDMailGtwStore) {
    super(store);
  }
}
